import { useMemo } from 'react'
import type { EvmChainId } from 'sushi/evm'
import { useBalanceProvider } from './balance-provider'

export function useRefetchBalances() {
  const {
    mutate: { refetchChain },
  } = useBalanceProvider()

  return useMemo(() => {
    return {
      refetchChain: (chainId: EvmChainId) => {
        refetchChain(chainId)
      },
    }
  }, [refetchChain])
}
